import { Col, Row } from "react-bootstrap";
import "./chartSkeleton.scss";

const ChartSkeleton = () => {
  return (
    <div>
      <Row xs={1} md={1} className="px-2 analytics-card-deck">
        <Col className="mb-4 px-2 analytics-card-box">
          <div className="chart_skeleton skeleton">
            <div className="loading-skeleton">
              <div className="">
                <div src="https://placekitten.com/300/200" className="card-img-top"></div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ChartSkeleton;
